export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-3.png?f59b0de41bc6aeccba1217c1a572b233";